<ng-container *transloco="let t">
  <div>
    <nz-page-header class="bg-slate-100" [nzGhost]="false">
      <nz-page-header-title class="text-primary flex items-center gap-2">
        {{ t('destinations.title') }}
        <nz-icon
          nz-tooltip
          nzTooltipPlacement="right"
          [nzTooltipArrowPointAtCenter]="true"
          [nzTooltipTitle]="'nav.featureTooltips.destination' | transloco"
          [nzTooltipOverlayStyle]="{
            'max-width': '400px',
            'min-width': '300px',
            'white-space': 'normal',
            'line-height': '1.5'
          }"
          nzType="info-circle"
          nzTheme="outline">
        </nz-icon>
      </nz-page-header-title>
      <nz-page-header-extra>
        <nz-space class="flex flex-col-reverse md:flex-row">
          <div class="pe-3 mt-2 md:mt-0">
            <nz-input-group nzSearch [nzAddOnAfter]="suffixButton" [nzSuffix]="inputClearTpl">
              <input
                type="text"
                nz-input
                [placeholder]="t('destinations.searchPlaceholder')"
                (keydown.enter)="this.search()"
                [(ngModel)]="searchName" />
            </nz-input-group>
            <ng-template #inputClearTpl>
              <span
                *ngIf="searchName"
                nz-icon
                class="ant-input-clear-icon"
                nzTheme="fill"
                nzType="close-circle"
                (click)="reset()">
              </span>
            </ng-template>
            <ng-template #suffixButton>
              <button
                nz-button
                nzType="primary"
                (click)="search()"
                nzSearch>
                {{ t('destinations.searchBtn') }}
              </button>
            </ng-template>
          </div>
          <div>
            <button
              *appHasAnyPrivilege="'DESTINATION.ADD'"
              nz-button
              nzType="primary"
              [routerLink]="'/admin/content/destinations/add'"
              class="flex items-center justify-center gap-2">
              <lucide-icon name="file-pen" class="icon-size"></lucide-icon>
              {{ t('destinations.addBtn') }}
            </button>
          </div>
        </nz-space>
      </nz-page-header-extra>
    </nz-page-header>
  </div>

  <div class="my-4">
    <nz-table
      #basicTable
      [nzData]="listOfData"
      #ZonesTable
      [nzShowSizeChanger]="pageSize.length > 5"
      [nzPageSizeOptions]="pageSize.pageSizeOptions"
      [nzLoading]="isLoading"
      [nzBordered]="true"
      [nzPageSize]="pageSize.pageSize"
      [nzPageIndex]="pageSize.pageIndex"
      [nzFrontPagination]="false"
      [nzTotal]="pageSize.length"
      (nzQueryParams)="onTableParamsChange($event)"
      [nzScroll]="{ x: '1100px' }">
      <thead>
        <tr>
          <th nzWidth="120px">{{ t('destinations.table.name') }}</th>
          <th nzWidth="100px">{{ t('destinations.table.customTitle') }}</th>
          <th nzWidth="60px" [nzSortFn]="sortColumn.compare">
            {{ t('destinations.table.createdDate') }}
          </th>
          <th nzWidth="80px" *appHasAnyPrivilege="'DESTINATION.EDIT,DESTINATION.DELETE'">
            {{ t('destinations.table.action') }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of basicTable.data">
          <td>{{ data.tableTitle }}</td>
          <td>{{ data?.titles[0]?.name }}</td>
          <td>{{ data.createdAt | date }}</td>
          <td *appHasAnyPrivilege="'DESTINATION.EDIT,DESTINATION.DELETE'">
            <div class="flex items-center gap-5">
              <button
                *appHasAnyPrivilege="'DESTINATION.EDIT'"
                nz-button
                nzType="default"
                nzSize="small"
                [routerLink]="'/admin/content/destinations/edit/' + data._id"
                class="flex items-center justify-center gap-2">
                <lucide-icon name="pencil" class="icon-size"></lucide-icon>
                {{ t('destinations.editBtn') }}
              </button>
              <button
                *appHasAnyPrivilege="'DESTINATION.DELETE'"
                nz-button
                nzType="default"
                nzSize="small"
                nzDanger
                (click)="showArchiveModal(data._id, data.city)"
                class="flex items-center justify-center gap-2">
                <lucide-icon name="trash-2" class="icon-size"></lucide-icon>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</ng-container>
